export default "__VITE_ASSET__BOaSkP5W__"